import api from './api'

export interface BetaInterestPayload {
  name: string
  email: string
  whatsapp?: string
  source?: string
  /** Campo trampa anti-bots: siempre vacío en una persona real. */
  website?: string
}

export const submitBetaInterest = async (payload: BetaInterestPayload): Promise<void> => {
  await api.post('/beta-interest', payload)
}
